import React, { lazy, useCallback } from 'react';
import { RememberedAccount } from '../../../reducers/login-reducer';
import { useLogin } from '../hooks/useLogin';
import { useRememberMe } from '../hooks/useRememberMe';

const BaseRememberedAccountsPage = lazy(() => import('./BasePage'));

const V1RememberedAccountsPage = () => {
  const rememberMe = useRememberMe({ loginStateSource: 'v1' });
  const { checkUsername } = useLogin();
  const onAccountSelected = useCallback(
    (account: RememberedAccount) => checkUsername(account.email, true),
    [checkUsername]
  );

  return <BaseRememberedAccountsPage {...rememberMe} onAccountSelected={onAccountSelected} />;
};

export default V1RememberedAccountsPage;
